module.exports = __webpack_public_path__ + "img/modal-top-element.15d2b421.png";